module.exports = __webpack_public_path__ + "img/service-duanxin3.c177c0db.svg";